import { render } from "./BoardNoticeEditPage.vue?vue&type=template&id=16d04682&lang=true"
import script from "./BoardNoticeEditPage.vue?vue&type=script&lang=js"
export * from "./BoardNoticeEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__